import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {Router} from '@angular/router';
import {CrudMarketsService} from '../../../../shared/services/crud-markets.service';

@Component({
  selector: 'app-markets-list',
  templateUrl: './markets-list.component.html',
  styleUrls: ['./markets-list.component.scss']
})
export class MarketsListComponent implements OnInit {

  observabledata?: Observable<any>;
  displayedcolumns: IDisplayColumn[] = [];
  entityadminuri: string;

  constructor(
    private router: Router,
    private marketservice: CrudMarketsService
  ) {
    this.entityadminuri = '/admin/markets';
  }

  ngOnInit(): void {
    this.observabledata = this.marketservice.getEntities();

    this.displayedcolumns = [
      {columnName: 'id', label: 'id'},
      {columnName: 'label', label: 'Label', isKeyColumn: true},
      {columnName: 'active', label: 'Active'}
    ] as IDisplayColumn[];
  }

  getObservableData(): Observable<any> | undefined {
    return this.observabledata;
  }

  getPostTreatmentCallback(): any {
    return (data: any): any => {
      return data.results;
    };
  }

  getCreateLink() {
    return [this.entityadminuri + '/create'];
  } // getCreateLink

  deleteEntityHandler(): any {
    return (idvalue) => {
      return this.marketservice.removeEntity(idvalue);
    };
  } // deleteEntityHandler

  deletePostTreatmentHandler() {
    return (idvalue, entityroot) => {
      // Refresh same page
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([entityroot]));
    };
  } // deletePostTreatmentHandler

  // Direct link accessible through the list
  // isKeyColumn true should be defined at this.displaycolumns
  // the [idColumnName]="'id'" should be defined at template
  getListEditPathCallback(): any {
    return (idvalue: string): string => {
      return this.entityadminuri + '/' + idvalue + '/edit';
    };
  }



}
